export enum ApiRoutesCoupons {
  Coupons = "/admin/coupons"
}

export enum CouponStatus {
  Active = "Active",
  Inactive = "Inactive "
}

export enum ScheduledCouponStatus {
  Upcoming = "Upcoming",
  Active = "Active",
  Expired = "Expired"
}

export enum CouponType {
  SharingCoupon = "SharingCoupon",
  QuantityResoldCoupon = "QuantityResoldCoupon",
  AmountResoldCoupon = "AmountResoldCoupon",
  OrdersResoldCoupon = "OrdersResoldCoupon",
  CustomCoupon = "CustomCoupon",
  SpendAndSaveCoupon = "SpendAndSaveCoupon",
  InfluencerCoupon = "InfluencerCoupon"
}

export enum CouponUsageScope {
  EachUser = "EachUser",
  OneUser = "OneUser"
}
